// licensesApi.js
import { BASE_URL, HEADERS } from "./config";

// export const fetchLicenses = async () => {
//     const API_URL = BASE_URL + "/license/list";

//     try {
//         const response = await fetch(API_URL, {
//             method: "GET",
//             headers: HEADERS,
//         });

//         if (!response.ok) {
//             throw new Error(`Failed to fetch licenses: ${response.statusText}`);
//         }

//         const data = await response.json();
//         return data.data.licenses || [];
//     } catch (error) {
//         console.error("Error fetching licenses:", error);
//         return [];
//     }
// };

export const fetchLicenses = async (page = 1, limit = 20) => {
    const API_URL = `${BASE_URL}/license/list?page=${page}&limit=${limit}`;

    try {
        const response = await fetch(API_URL, {
            method: "GET",
            headers: HEADERS,
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch licenses: ${response.statusText}`);
        }

        const data = await response.json();

        console.log("✅ API Response:", data); // Debugging log

        return {
            licenses: Array.isArray(data.data.licenses) ? data.data.licenses : [], // Ensure licenses is always an array
            totalPages: data.data.totalPages || 1,
        };
    } catch (error) {
        console.error("Error fetching licenses:", error);
        return { licenses: [], totalPages: 1 };
    }
};


export const fetchUsers = async () => {
    const API_URL = BASE_URL + "/users/list";

    try {
        const response = await fetch(API_URL, {
            method: "GET",
            headers: HEADERS,
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch users: ${response.statusText}`);
        }

        const data = await response.json();
        return data.data.users || [];
    } catch (error) {
        console.error("Error fetching users:", error);
        return [];
    }
};

export const createLicense = async (licenseOwner) => {
    const API_URL = BASE_URL + "/license/generate";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify({ licenseOwner }),
        });

        if (!response.ok) {
            throw new Error(`Failed to create license: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error creating license:", error);
        return { success: false, error };
    }
};

export const deleteLicense = async (licenseKey) => {
    const API_URL = BASE_URL + "/license/delete";

    try {
        const response = await fetch(API_URL, {
            method: "DELETE",
            headers: HEADERS,
            body: JSON.stringify({ licenseKey }),
        });

        if (!response.ok) {
            throw new Error(`Failed to delete license: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error deleting license:", error);
        return { success: false, error };
    }
};

export const updateLicense = async (licenseKey, updates) => {
    const API_URL = BASE_URL + "/license/update";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify({ licenseKey, updates }),
        });

        if (!response.ok) {
            throw new Error(`Failed to update license: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error updating license:", error);
        return { success: false, error: error.message };
    }
};

export const licenseConnectionDeactivation = async (licenseKey) => {
    const API_URL = BASE_URL + "/license/deactivate";
    const body = JSON.stringify({ licenseKey });
    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body
        });

        if (!response.ok) {
            throw new Error(`Failed to deeactivate license: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error deactivating license:", error);
        return { success: false, error: error.message };
    }
};


export const sendEmailToClient = async (data) => {
    const API_URL = BASE_URL + "/license/detailstoclient";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Failed to send data to client: ${response.statusText}`);
        }

        return { success: true };

    } catch (error) {
        console.error("Error sending data to client:", error);
        return { success: false, error: error.message };
    }
};

export const suspendLicense = async (licenseKey) => {
    const API_URL = BASE_URL + "/license/suspend";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify({ licenseKey }),
        });

        if (!response.ok) {
            throw new Error(`Failed to suspend license: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error suspending license:", error);
        return { success: false, error: error.message };
    }
};
